module.exports = __webpack_public_path__ + "img/CRC1_DC.daab13c1.png";